import * as yup from "yup";

export const noteValidator = yup.object({
  text: yup.string().required(),
});
